export enum AttachmentDisposition {
  INLINE = 'inline',
  ATTACHMENT = 'attachment',
}

export interface CommentAttachment {
  id: string;
  fileName: string;
  s3Key: string;
  disposition?: AttachmentDisposition;
  url?: string;
}

/**
 * Represents a single attachment that failed validation during a comment mutation.
 */
export interface FailedAttachmentInfo {
  attachmentId: string;
  fileName?: string;
  scanStatus?: string;
  /** GraphQLInternalErrorCode value, typed as string to prevent a circular dep. */
  reason?: string;
  message: string;
}

/**
 * A single resolved mention inside a comment message. Derived on read from the
 * serialized `@[Name](userId)` tokens that survived sanitization — not stored.
 */
export interface CommentMention {
  userId: string;
  name: string;
}

export interface InboxEntryComment {
  inboxEntryId: string;
  id: string;
  userId: string;
  userName: string;
  message?: string;
  /** Resolved from `message` on read; the message text is the source of truth. */
  mentions?: CommentMention[];
  attachments?: CommentAttachment[];
  createdAt: number;
  updatedAt: number;
}

export interface PaginatedInboxEntryCommentsResponse {
  comments: InboxEntryComment[];
  exclusiveStartKey: string | null;
}

export interface CommentPresignedUrl {
  url: string;
  fields: string; // JSON.stringify(Record<string, string>)
  attachmentId: string;
}

export interface GenerateCommentPresignedUrlInput {
  inboxEntryId: string;
  fileName: string;
  fileType: string;
}

export interface CreateCommentInput {
  inboxEntryId: string;
  message?: string;
  newAttachmentIds?: string[];
}

export interface UpdateCommentInput {
  inboxEntryId: string;
  commentId: string;
  message?: string;
  attachmentIds?: string[];
  newAttachmentIds?: string[];
}

export interface DeleteCommentInput {
  inboxEntryId: string;
  commentId: string;
}
